import { Routes } from '../api-routes'
import { DocumentFileDTO, DocumentNoteDTO } from '../dtos/document'
import { getPath, setP } from './helpers'

export namespace DocumentsRoutes {
  export namespace uploadOne {
    export function call(p = setP(['organizationId', 'beneficiaryId'])) {
      return getPath(p, { suffix: `${Routes.Documents}/upload` })
    }
    export type Request = { file: File }
    export type Response = { document: DocumentFileDTO }
  }

  export namespace restoreOne {
    export function call(
      p = setP(['organizationId', 'beneficiaryId', 'documentId']),
    ) {
      return getPath(p, { suffix: 'restore' })
    }
    export type Response = { document: DocumentFileDTO | DocumentNoteDTO }
  }

  export namespace createOne {
    export function call(p = setP(['organizationId', 'beneficiaryId'])) {
      return getPath(p, { suffix: `${Routes.Documents}/create` })
    }
    export type Request = { fields: Pick<DocumentNoteDTO, 'content' | 'type'> }
    export type Response = { document: DocumentNoteDTO }
  }

  export namespace patchOne {
    export function call(p = setP(['organizationId', 'beneficiaryId'])) {
      return getPath(p, { suffix: Routes.Documents })
    }
    export type Request = {
      fields:
        | Pick<DocumentNoteDTO, 'id' | 'content'>
        | Pick<DocumentFileDTO, 'id' | 'title'>
    }
    export type Response = { document: DocumentFileDTO | DocumentNoteDTO }
  }

  export namespace deleteOne {
    export function call(
      p = setP(['organizationId', 'beneficiaryId', 'documentId']),
    ) {
      return getPath(p)
    }
    export type Response = { success: boolean }
  }

  export namespace get {
    export function call(p = setP(['organizationId', 'beneficiaryId'])) {
      return getPath(p, { suffix: Routes.Documents })
    }
    export type Response = { documents: (DocumentFileDTO | DocumentNoteDTO)[] }
  }

  export namespace getTemporaryUrl {
    export function call(
      p = setP(['organizationId', 'beneficiaryId', 'documentId']),
    ) {
      return getPath(p)
    }
    export type Response = { url: string }
  }
}
